import { css } from 'lit';
export const chatbotConversationRating = css`
    :host .feedback {
        display: none;
        margin: 0.625rem 0;
    }
    :host .feedback-content {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
    }
    :host .feedback-confirm {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }
`;
